import React, { useState } from 'react';
import { Tabs } from 'antd';
import CategoryRecordsView from '../components/CategoryRecordsView';
import RecordForm from '../components/RecordForm';

import { TRANSACTION_REFERENCE } from '../types/accountPurposes';

const recordTypes = TRANSACTION_REFERENCE;

const OtherRecordsPage = () => {
  const [recordsReloadKey, setRecordsReloadKey] = useState(0);
  const handleRecordAdded = () => setRecordsReloadKey(k => k + 1);
  return (
    <div>
      <h2>Other Expenses</h2>
      <RecordForm
              type='expense'
              showAllPurposes={true}
              onRecordAdded={handleRecordAdded}
            />
      <Tabs defaultActiveKey={recordTypes[0].value}>
        
        {recordTypes.map(rt => (
          
            
            <Tabs.TabPane tab={rt.label} key={rt.value}>
            <CategoryRecordsView category={rt.value} recordsReloadKey={recordsReloadKey} />
          </Tabs.TabPane>
        ))}
      </Tabs>
    </div>
  );
};
export default OtherRecordsPage;
